export default __webpack_public_path__ + "static/media/logo-humane-two.1a2ec3ac.svg";